import "./index.scss";
import {
  GeneralMediumChevronDown,
  GeneralMediumChevronUp,
  GeneralMediumLanguage,
  GeneralSmallCheckTick,
} from "@wise-emotions/react-icons";
import { LangProp } from "components/Header";
import { Link } from "gatsby";
import { useMenu } from "utilities/MenuProvider";
import { useOnClickOutside } from "@wise-emotions/react-hooks";
import React, { useCallback, useRef, useState } from "react";
import cn from "classnames";

type Props = {
  hasBackground?: boolean;
};

const LangSelect = ({ hasBackground }: Props) => {
  const { langs } = useMenu();
  const [isOpen, setIsOpen] = useState(false);
  const selectedOption = langs.find(({ current }) => current) || langs[0];
  const ref = useRef<HTMLDivElement | null>(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const onClickOutside = useCallback(() => {
    if (isOpen) {
      setIsOpen(false);
    }
  }, [isOpen]);

  useOnClickOutside(ref, onClickOutside);

  return (
    <div
      ref={ref}
      className={cn("lang-select", {
        "lang-select--no-background": !hasBackground,
      })}
    >
      <button
        type="button"
        className="lang-select__select-box"
        onClick={toggleDropdown}
      >
        <div className="lang-select__icon">
          <GeneralMediumLanguage />
        </div>
        <span className="lang-select__select-box--selected">
          {selectedOption.label}
        </span>
        {isOpen ? <GeneralMediumChevronUp /> : <GeneralMediumChevronDown />}
      </button>
      {isOpen && (
        <div className="lang-select__options-container">
          {langs.map(({ label, current, link }: LangProp) => (
            <div className="lang-select__options-container__option-wrap">
              <Link
                key={label}
                className="lang-select__options-container__option"
                to={link}
                data-tracking="language_menu"
              >
                <div className="lang-select__options-container__label">
                  {label}
                </div>
                {current && <GeneralSmallCheckTick />}
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LangSelect;
